module.exports = __webpack_public_path__ + "img/shinka.2dcacc03.png";